'use client';
import { useMemo } from 'react';
import { Icon } from '@weareconceptstudio/core';

//* Helpers
import { getPageNumbers } from './functions';

//* Style
import PaginationStyle from './style';

const Pagination = ({ total, className = '', pageSize, onCategoryChange, pageNumbersToShow = 3, currentRefinement = 1, searchParams }) => {
	//! Current Page
	const currentPage = useMemo(() => Number(searchParams.get('page')) || currentRefinement || 1, [searchParams, currentRefinement]);

	//! Last Page
	const isLastPage = currentPage * pageSize >= total;

	//! Page Numbers
	const pageNumbers = getPageNumbers({
		currentPage,
		pageSize,
		total,
		pageNumbersToShow,
	});

	if (total <= pageSize) return null;

	return (
		<PaginationStyle className={`pagination-wrapper user-select-none ${className}`}>
			<div className='pagination-inner-wrapper'>
				<div
					onClick={() => currentPage > 1 && onCategoryChange('page', currentPage - 1)}
					className={`prev-btn ${currentPage === 1 ? 'disable' : ''}`}>
					<Icon
						name='arrow'
						className='left-arrow'
					/>
				</div>

				{pageNumbers.map((pageNumber, index) =>
					pageNumber === '...' ? (
						<div
							key={index}
							className='dots'>
							<div className='dots-item' />
							<div className='dots-item' />
							<div className='dots-item' />
						</div>
					) : (
						<div
							key={index}
							onClick={() => onCategoryChange('page', pageNumber)}
							className={`pagination-item ${pageNumber === currentPage ? 'active' : ''}`}>
							{String(pageNumber).padStart(2, '0')}
						</div>
					)
				)}

				<div
					className={`next-btn ${isLastPage ? 'disable' : ''}`}
					onClick={() => !isLastPage && onCategoryChange('page', currentPage + 1)}>
					<Icon
						name='arrow'
						className='right-arrow'
					/>
				</div>
			</div>
		</PaginationStyle>
	);
};

export default Pagination;
